module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAONJREFUWIXtlDEOgjAUhv+HE5OcgDNwBBYTjiE3YOIQXTgCHMGRTbwKcSfqCKYuDIgtUvNoYtJvfU2/L036AIfDYYGkFcekFaVqRjbkBJQAIIGqDvN0OvdsyUcu8zObvcBcLoG0DvPKSsBa+SYBJnL2AFM5a8AvckDzC+KuCGzIlQFxVwT+vT/rFgenXBngP/oTCBEB2u3FJVcGDB4yKeUNAJYiOOSj45PDVUS7p2yIaD9e/rZCueTagKUITvligCaiISDmkn8NUEVwylcFqCK45KsDphEgyrjkxphuSIfD8Re8AETqmQGJA5/tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_transaction_check.png
// module id = 248
// module chunks = 1